export default __webpack_public_path__ + "static/media/copy-light.87805b5a.svg";